<h3>{{ 'alias.confirm.delete.title' | translate }}</h3>
<p>{{ 'alias.confirm.delete.description' | translate }}</p>
<a class="close-reveal-modal"><i class="icon-Close"></i></a>
<div class="rs-padding-bottom2">
  <button (click)="onConfirm()" type="button" class="rs-btn rs-no-margin-bottom rs-margin-right2">
    {{ 'alias.confirm.delete.yes.button.title' | translate }}
  </button>
  <a href="javascript:void(0)" (click)="onCancel()">{{
    'alias.confirm.delete.cancel.link.title' | translate
  }}</a>
</div>
